<script setup lang="ts">
// Polls the static /version.json this build shipped with against whatever
// the server is currently serving — a plain deploy-time-generated file
// (see nuxt.config.ts), not an API, so this works against the Cloudflare
// Pages static host with no backend involved. Never auto-reloads: this
// app's whole mixer state is session-only overrides (see overrides.ts),
// so forcing a reload out from under someone mid-edit would silently
// throw away real work — just surfaces it and lets them choose when.
const loadedBuildId = useRuntimeConfig().public.buildId
const updateAvailable = ref(false)
const dismissed = ref(false)

async function checkForUpdate() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return
    const data = await res.json()
    if (data?.buildId && data.buildId !== loadedBuildId) updateAvailable.value = true
  } catch {
    // offline or the request just failed — try again next tick, not worth surfacing
  }
}

let timer: ReturnType<typeof setInterval> | null = null
onMounted(() => {
  timer = setInterval(checkForUpdate, 5 * 60 * 1000)
  // Also check whenever the tab regains focus — catches "left it open
  // overnight, came back the next day" without waiting on the interval.
  document.addEventListener('visibilitychange', onVisibility)
})
onUnmounted(() => {
  if (timer) clearInterval(timer)
  document.removeEventListener('visibilitychange', onVisibility)
})
function onVisibility() {
  if (document.visibilityState === 'visible') checkForUpdate()
}
function reload() {
  window.location.reload()
}
</script>

<template>
  <div
    v-if="updateAvailable && !dismissed"
    class="fixed inset-x-0 top-0 z-[60] flex items-center justify-center gap-3 border-b border-accent-dim bg-panel px-4 py-2 shadow-lg"
  >
    <span class="text-xs text-ink">A new version of MPC1000.com is available.</span>
    <button
      type="button"
      class="rounded border border-accent bg-accent px-2.5 py-1 text-[12px] font-semibold uppercase tracking-wide text-[#1a0f04]"
      @click="reload"
    >
      Reload
    </button>
    <button type="button" class="text-muted-dim hover:text-muted" title="Dismiss" @click="dismissed = true">✕</button>
  </div>
</template>
